export const AccountRoutes = {
    Base: '/account',
    ResetPassword: 'reset-password',
};
